import React, {useEffect, useRef, useState} from 'react';
import {useRecoilState} from "recoil";
import {loadingAtom} from "../atoms";
import Cookies from "js-cookie";
import {isDateAfterCurrent, isOver} from "../core/date";
import {useNavigate, useParams} from "react-router-dom";

import {formatLocalDate, parseLocalDate} from "../utils/utils";
import DateSelector from "./DateSelector";
import DeleteButton from '../components/common/DeleteButton';
import { showConfirm, showAlert } from '../core/dialog';
const CustomerAutoFilling_Kids = (props, {onCustomerAdded}) => {
    const {kidIndex} = useParams();
    const navigate = useNavigate();
    const customerKey = Cookies.get('customerKey');
    const companyImg = Cookies.get('selfRegistrationImagePath') || null;
    const [customerKeyValid, setCustomerKeyValid] = useState(false);

    const [, setLoading] = useRecoilState(loadingAtom);

    const currentCustomerAutoFilling = Cookies.get('customerAutoFilling');

    const inputTextKidName = useRef();
    const inputTextKidBirthDateDay = useRef();
    const inputTextKidBirthDateMonth = useRef();
    const inputTextKidBirthDateYear = useRef();

    const newEntity = {
        id: undefined,
        name: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        neighborhood: '',
        cep: '',
        city: '',
        state: '',
        phone: '',
        email: '',
        instagram: '@',
        birthDate: undefined,
        rg: '',
        cpf: '',
        delivery: false,
        spaceBorneDelivery: false,
        howDidYouFindUs: '',
        referral: '',
        kids: []
    };

    const newKid = {name: '', birthDate: undefined};


    const [formData, setFormData] = useState(currentCustomerAutoFilling ? JSON.parse(currentCustomerAutoFilling) : newEntity);
    const [currentKid, setCurrentKid] = useState(newKid);

    useEffect(() => {
        // Validate customer key
        if (customerKey) {
            setCustomerKeyValid(true);
        } else {
            setCustomerKeyValid(false);
            navigate(`/autocadastro/linkInvalido`);
            return;
        }
        
        setCurrentKid(currentKid);
        if(inputTextKidName.current) {
            inputTextKidName.current.focus();
        }
    }, [customerKey, kidIndex, navigate])

    useEffect(() => {
        const kid = Number(kidIndex) === formData.kids.length ? newKid : formData.kids[kidIndex];
        setCurrentKid(kid);
    }, [kidIndex])
    const handleSaveButtonClick = async () => {

        try {
            if (validateInputs()) {
                await save();
            }
        } catch (error) {
            console.error('Error saving:', error);
            showAlert('Error ao salvar.');
        }
    };

    function validateInputs() {


        if (!currentKid.name || currentKid.name === '') {
            showAlert('Preencha o campo nome.');
            if(inputTextKidName.current) {
                inputTextKidName.current.focus();
            }
            return false;
        }

        if (!currentKid.birthDate || currentKid.birthDate === '') {
            showAlert('Preencha o campo data de nascimento.');
            if(inputTextKidBirthDateDay.current) {
                inputTextKidBirthDateDay.current.focus();
            }
            return false;
        }

        if (isOver(parseLocalDate(currentKid.birthDate), 10)) {
            showAlert('Data de nascimento inválida. Maior que 10 anos.');
            if(inputTextKidBirthDateDay.current) {
                inputTextKidBirthDateDay.current.focus();
            }
            return false;
        }

        if (isDateAfterCurrent(parseLocalDate(currentKid.birthDate))) {
            showAlert('Data de nascimento inválida. Data posterior à data de hoje.');
            if(inputTextKidBirthDateDay.current) {
                inputTextKidBirthDateDay.current.focus();
            }
            return false;
        }

        return true;
    }

    async function save() {
        const idx = Number(kidIndex);
        const isNewKid = idx === formData.kids.length;

        if (isNewKid) {
            formData.kids.push(currentKid);
        } else {
            formData.kids[idx] = currentKid;
        }
        Cookies.set('customerAutoFilling', JSON.stringify(formData));

        const isLastKid = idx === formData.kids.length - 1;
        if (isLastKid) {
            if (await showConfirm('Deseja adicionar mais uma criança?')) {
                setCurrentKid(newKid);
                navigate(`/autocadastro/crianca/${idx + 1}`);
            } else {
                navigate(`/autocadastro/sobre`);
            }
        } else {
            navigate(`/autocadastro/crianca/${idx + 1}`);
        }
    }


    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setCurrentKid((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleBirthDateChange = (dateStr) => {
        setCurrentKid((prevData) => ({
            ...prevData,
            birthDate: dateStr
        }));
    };

    function handleBackButtonClick() {
        if(Number(kidIndex) === 0) {
            navigate(`/autocadastro/contato`);
        } else {
            navigate(`/autocadastro/crianca/${(kidIndex - 1)}`);
        }
    }

    async function handleRemoveButtonClick() {
        if (!await showConfirm('Deseja realmente excluir esta criança?')) return;
        const novaLista = [...formData.kids];
        novaLista.splice(Number(kidIndex), 1);
        const newFormData = ({
            ...formData,
            kids: novaLista
        });
        setFormData(newFormData);
        Cookies.set('customerAutoFilling', JSON.stringify(newFormData));
        if(Number(kidIndex) === 0) {
            if(novaLista.length > 0) {
                setCurrentKid(novaLista[0]);
            } else {
                setCurrentKid(newKid);
            }
            navigate(`/autocadastro/crianca/0`);
        } else {
            setCurrentKid(formData.kids[Number(kidIndex)-1]);
            navigate(`/autocadastro/crianca/${(Number(kidIndex) - 1)}`);
        }
    }

    return (
        <div>

            {companyImg && <div style={{textAlign: 'center'}}><img src={companyImg} alt="Logo" style={{maxHeight: '120px', width: 'auto'}}/></div>}
            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <div style={{width: '300px'}}>Nome da Criança:</div>
                <input style={{width: '300px'}} ref={inputTextKidName} type="text" id="name" value={currentKid.name} name="name"
                       onChange={handleChange}/>
            </div>
            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <div style={{width: '320px'}}>Data de nascimento da criança:</div>
                <DateSelector
                    value={currentKid.birthDate}
                    onChange={handleBirthDateChange}
                    dayRef={inputTextKidBirthDateDay}
                    monthRef={inputTextKidBirthDateMonth}
                    yearRef={inputTextKidBirthDateYear}
                    minYear={new Date().getFullYear() - 10}
                />
            </div>

            <div style={{marginTop: '10px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', flexWrap: 'nowrap'}}>
                {formData.kids.length > 1 && Number(kidIndex) < formData.kids.length && (
                    <DeleteButton title="Remover" onClick={handleRemoveButtonClick}/>
                )}
                <button onClick={handleBackButtonClick} style={{opacity: 0.5, padding: '10px 24px', width: '120px'}}>Voltar</button>
                <button onClick={handleSaveButtonClick} style={{fontWeight: 'bold', padding: '10px 24px', width: '120px'}}>Continuar</button>
            </div>


        </div>
    );
};

export default CustomerAutoFilling_Kids; 